// import React, { useState } from 'react';
// import { FileText, CreditCard, Ticket, UserCheck, Briefcase, Globe, Phone, Mail, MapPin, Clock, ChevronRight, Car, Home, Zap, GraduationCap, Heart, Shield, MessageCircle, Send, X, Star, Quote, ArrowUp, ChevronLeft } from 'lucide-react';
// import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
// import ArticlesSection from './ArticlesSection';

// // WhatsApp Button Component
// const WhatsAppButton = ({ phoneNumber = '919999999999', message = 'Hello, I need help with a service' }) => {
//   const handleWhatsAppClick = () => {
//     const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <button 
//       className="whatsapp-float whatsapp-pulse" 
//       onClick={handleWhatsAppClick}
//       aria-label="Contact us on WhatsApp"
//     >
//           <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 1219.547 1225.016" id="whatsapp">
//       <path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"></path>
//       <linearGradient id="a" x1="609.77" x2="609.77" y1="1190.114" y2="21.084" gradientUnits="userSpaceOnUse">
//         <stop offset="0" stop-color="#20b038"></stop>
//         <stop offset="1" stop-color="#60d66a"></stop>
//       </linearGradient>
//       <path fill="url(#a)" d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"></path>
//       <path fill="#FFF" fill-rule="evenodd" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z" clip-rule="evenodd"></path>
//       <path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"></path>
//     </svg>
      
//     </button>
//   );
// };

// // Service Request Form Component
// const ServiceRequestForm = ({ language = 'en' }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     service: '',
//     message: ''
//   });
//   const [submitted, setSubmitted] = useState(false);
//   const [error, setError] = useState('');  // Initialize the error state

//   const content = {
//     en: {
//       title: 'Request a Service',
//       subtitle: 'Fill the form and we will contact you soon',
//       name: 'Your Name',
//       phone: 'Phone Number',
//       service: 'Select Service',
//       message: 'Additional Details (Optional)',
//       submit: 'Submit Request',
//       success: 'Thank you! We will contact you soon.',
//       services: [
//         'Aadhar Card Services',
//         'PAN Card Services',
//         'Driving License',
//         'Passport Services',
//         'Ration Card',
//         'Vehicle Registration',
//         'Railway Ticket Booking',
//         'Income Tax Return',
//         'PF Withdrawal',
//         'Other Services'
//       ]
//     },
//     mr: {
//       title: 'सेवा विनंती करा',
//       subtitle: 'फॉर्म भरा आणि आम्ही लवकरच तुमच्याशी संपर्क साधू',
//       name: 'तुमचे नाव',
//       phone: 'फोन नंबर',
//       service: 'सेवा निवडा',
//       message: 'अतिरिक्त तपशील (पर्यायी)',
//       submit: 'विनंती सबमिट करा',
//       success: 'धन्यवाद! आम्ही लवकरच तुमच्याशी संपर्क साधू.',
//       services: [
//         'आधार कार्ड सेवा',
//         'पॅन कार्ड सेवा',
//         'ड्रायव्हिंग लायसन्स',
//         'पासपोर्ट सेवा',
//         'रेशन कार्ड',
//         'वाहन नोंदणी',
//         'रेल्वे तिकीट बुकिंग',
//         'आयकर रिटर्न',
//         'पीएफ पैसे काढणे',
//         'इतर सेवा'
//       ]
//     }
//   };

//   const t = content[language];

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   console.log('Form submitted:', formData);
//   //   setSubmitted(true);
    
//   //   setTimeout(() => {
//   //     setSubmitted(false);
//   //     setFormData({ name: '', phone: '', service: '', message: '' });
//   //     setIsOpen(false);
//   //   }, 3000);
//   // };

//   const handleSubmit = async (e) => {
//   e.preventDefault();
  
//  const access_key=process.env.REACT_APP_WEB3FORMS_KEY; // Replace with your Web3Forms API key
//  console.log("Web3Forms API Key:", process.env.REACT_APP_WEB3FORMS_KEY);

//   const formDataToSend = new FormData();
//   formDataToSend.append('access_key', access_key); 
//   formDataToSend.append('name', formData.name);
//   formDataToSend.append('phone', formData.phone);
//   formDataToSend.append('service', formData.service);
//   formDataToSend.append('message', formData.message);

//   try {
//     const response = await fetch('https://api.web3forms.com/submit', {
//       method: 'POST',
//       body: formDataToSend,
//       headers: {
//         'Accept': 'application/json',
//       }
//     });
//  console.log('Response Status:', response.status); 
   
//     if (!response.ok) {
//       const errorData = await response.json();
//       console.error('Form submission failed:', errorData);
//       setError('There was an error submitting the form. Please try again later.');
//       return;
//     }

//     const result = await response.json();
//     if (result.success) {
//       setSubmitted(true);
//       setTimeout(() => {
//         setSubmitted(false);
//         setFormData({ name: '', phone: '', service: '', message: '' });
//         setIsOpen(false);
//       }, 3000);
//     } else {
//       setError('There was an error submitting the form. Please try again later.');
//     }
//   } catch (err) {
//     console.error('Error during fetch:', err);
//     setError('There was an error submitting the form. Please try again later.');
//   }
// };

//   return (
//     <>
//       <button 
//         className="request-form-button"
//         onClick={() => setIsOpen(true)}
//       >
//         <Send size={18} />
//         {language === 'mr' ? 'सेवा विनंती' : 'Request Service'}
//       </button>

//       {isOpen && (
//         <div className="form-overlay" onClick={() => setIsOpen(false)}>
//           <div className="form-container" onClick={(e) => e.stopPropagation()}>
//             <button className="close-button" onClick={() => setIsOpen(false)}>
//               <X size={20} />
//             </button>

//             {!submitted ? (
//               <>
//                 <div className="form-header">
//                   <h3>{t.title}</h3>
//                   <p>{t.subtitle}</p>
//                 </div>

//                 <form onSubmit={handleSubmit} >
//                   <div className="form-group">
//                         <input type="hidden" name="access_key" value="${process.env.REACT_APP_WEB3FORMS_KEY}"/>

//                     <label>{t.name} *</label>

//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       required
//                       placeholder={language === 'mr' ? 'तुमचे पूर्ण नाव' : 'Enter your full name'}
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>{t.phone} *</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       required
//                       pattern="[0-9]{10}"
//                       placeholder="9876543210"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>{t.service} *</label>
//                     <select
//                       name="service"
//                       value={formData.service}
//                       onChange={handleChange}
//                       required
//                     >
//                       <option value="">{language === 'mr' ? 'सेवा निवडा' : 'Choose a service'}</option>
//                       {t.services.map((service, index) => (
//                         <option key={index} value={service}>
//                           {service}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>{t.message}</label>
//                     <textarea
//                       name="message"
//                       value={formData.message}
//                       onChange={handleChange}
//                       placeholder={language === 'mr' ? 'काही विशेष माहिती...' : 'Any specific requirements...'}
//                     />
//                   </div>
//                       <input type="hidden" name="redirect" value="https://web3forms.com/success"/>
//                   <button type="submit" className="submit-button">
//                     <Send size={18} />
//                     {t.submit}
//                   </button>
//                 </form>
//               </>
//             ) : (
//               <div className="success-message">
//                 <h4>✓ {t.success}</h4>
//                 <p>{language === 'mr' ? 'आम्ही २४ तासांत तुमच्याशी संपर्क साधू.' : 'We will contact you within 24 hours.'}</p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// // Testimonials Component
// const Testimonials = ({ language = 'en' }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const content = {
//     en: {
//       title: 'What Our Customers Say',
//       subtitle: 'Trusted by thousands of satisfied customers',
//       testimonials: [
//         {
//           name: 'Rajesh Kumar',
//           service: 'PAN Card Service',
//           rating: 5,
//           text: 'Excellent service! Got my PAN card within a week. The staff was very helpful and guided me through the entire process. Highly recommended!',
//           location: 'Thane West'
//         },
//         {
//           name: 'Priya Sharma',
//           service: 'Passport Application',
//           rating: 5,
//           text: 'Very professional and efficient. They helped me with my passport application and I received it without any hassle. Great experience!',
//           location: 'Kalwa'
//         },
//         {
//           name: 'Amit Patil',
//           service: 'Driving License',
//           rating: 5,
//           text: 'Fast and reliable service. Got my driving license renewed quickly. The pricing was also very reasonable. Will definitely come back for other services.',
//           location: 'Mumbra'
//         },
//         {
//           name: 'Sneha Desai',
//           service: 'Aadhar Card Update',
//           rating: 5,
//           text: 'Very helpful staff! They corrected my Aadhar details efficiently. The whole process was smooth and hassle-free. Thank you!',
//           location: 'Thane East'
//         },
//         {
//           name: 'Vikram Singh',
//           service: 'Railway Ticket Booking',
//           rating: 5,
//           text: 'Booked my tatkal tickets easily through them. They are quick and efficient. Saved me a lot of time and effort. Excellent service!',
//           location: 'Dombivli'
//         }
//       ]
//     },
//     mr: {
//       title: 'ग्राहकांचे अनुभव',
//       subtitle: 'हजारो समाधानी ग्राहकांचा विश्वास',
//       testimonials: [
//         {
//           name: 'राजेश कुमार',
//           service: 'पॅन कार्ड सेवा',
//           rating: 5,
//           text: 'उत्कृष्ट सेवा! एका आठवड्यात माझे पॅन कार्ड मिळाले. कर्मचारी खूप मदतगार होते आणि संपूर्ण प्रक्रियेत मार्गदर्शन केले. अत्यंत शिफारसीय!',
//           location: 'ठाणे पश्चिम'
//         },
//         {
//           name: 'प्रिया शर्मा',
//           service: 'पासपोर्ट अर्ज',
//           rating: 5,
//           text: 'अतिशय व्यावसायिक आणि कार्यक्षम. त्यांनी माझ्या पासपोर्ट अर्जात मदत केली आणि मला कोणत्याही अडचणीशिवाय मिळाले. उत्तम अनुभव!',
//           location: 'कळवा'
//         },
//         {
//           name: 'अमित पाटील',
//           service: 'ड्रायव्हिंग लायसन्स',
//           rating: 5,
//           text: 'जलद आणि विश्वासार्ह सेवा. माझे ड्रायव्हिंग लायसन्स लवकर नूतनीकरण झाले. किंमत देखील खूप वाजवी होती. इतर सेवांसाठी नक्कीच परत येईन.',
//           location: 'मुंब्रा'
//         },
//         {
//           name: 'स्नेहा देसाई',
//           service: 'आधार कार्ड अपडेट',
//           rating: 5,
//           text: 'खूप मदतगार कर्मचारी! त्यांनी माझे आधार तपशील कार्यक्षमतेने दुरुस्त केले. संपूर्ण प्रक्रिया सुलभ आणि अडचण मुक्त होती. धन्यवाद!',
//           location: 'ठाणे पूर्व'
//         },
//         {
//           name: 'विक्रम सिंग',
//           service: 'रेल्वे तिकीट बुकिंग',
//           rating: 5,
//           text: 'त्यांच्याद्वारे माझी तत्काळ तिकिटे सहजपणे बुक केली. ते जलद आणि कार्यक्षम आहेत. माझा खूप वेळ आणि मेहनत वाचवली. उत्कृष्ट सेवा!',
//           location: 'डोंबिवली'
//         }
//       ]
//     }
//   };

//   const t = content[language];

//   const nextTestimonial = () => {
//     setCurrentIndex((prev) => (prev + 1) % t.testimonials.length);
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex((prev) => (prev - 1 + t.testimonials.length) % t.testimonials.length);
//   };

//   const currentTestimonial = t.testimonials[currentIndex];

//   return (
//     <section className="testimonials-section">
//       <div className="testimonials-container">
//         <div className="testimonials-header">
//           <h3>{t.title}</h3>
//           <p>{t.subtitle}</p>
//         </div>

//         <div className="testimonials-slider">
//           <div className="testimonial-card">
//             <Quote size={48} className="quote-icon" />
            
//             <div className="rating">
//               {[...Array(currentTestimonial.rating)].map((_, i) => (
//                 <Star key={i} size={20} fill="#FFB800" color="#FFB800" />
//               ))}
//             </div>

//             <p className="testimonial-text">"{currentTestimonial.text}"</p>

//             <div className="testimonial-author">
//               <div className="author-name">{currentTestimonial.name}</div>
//               <div className="author-service">{currentTestimonial.service}</div>
//               <div className="author-location">{currentTestimonial.location}</div>
//             </div>
//           </div>

//           <div className="slider-controls">
//             <button className="slider-button" onClick={prevTestimonial}>
//               <ChevronLeft size={24} />
//             </button>
//             <button className="slider-button" onClick={nextTestimonial}>
//               <ChevronRight size={24} />
//             </button>
//           </div>

//           <div className="slider-dots">
//             {t.testimonials.map((_, index) => (
//               <div
//                 key={index}
//                 className={`dot ${index === currentIndex ? 'active' : ''}`}
//                 onClick={() => setCurrentIndex(index)}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // Scroll To Top Component
// const ScrollToTop = () => {
//   const [isVisible, setIsVisible] = useState(false);

//   React.useEffect(() => {
//     const toggleVisibility = () => {
//       if (window.pageYOffset > 300) {
//         setIsVisible(true);
//       } else {
//         setIsVisible(false);
//       }
//     };

//     window.addEventListener('scroll', toggleVisibility);

//     return () => {
//       window.removeEventListener('scroll', toggleVisibility);
//     };
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   return (
//     <button
//       className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
//       onClick={scrollToTop}
//       aria-label="Scroll to top"
//     >
//       <ArrowUp size={24} />
//     </button>
//   );
// };

// // Main HomePage Component
// export default function HomePage() {
//   const [language, setLanguage] = useState('mr');
//   const [activeTab, setActiveTab] = useState(0);
//   const [expandedCard, setExpandedCard] = useState(null);

//   const toggleCard = (index) => {
//     setExpandedCard(expandedCard === index ? null : index);
//   };

//   const content = {
//     en: {
//       nav: {
//         home: 'Home',
//         services: 'Services',
//         about: 'About Us',
//         contact: 'Contact'
//       },
//       hero: {
//         title: 'Aaple Sarkar E-Seva Kendra',
//         subtitle: 'Your One-Stop Solution for All Government & Online Services',
//         description: 'We provide complete assistance for government forms, online registrations, document services, and much more. Fast, reliable, and affordable services at your doorstep.',
//         cta: 'View Services',
//         cta2: 'Contact Us'
//       },
//       why: {
//         title: 'Why Choose Us?',
//         points: [
//           {
//             title: 'Fast and reliable service',
//             detail: 'We complete most services within 24-48 hours. Our efficient process ensures you get your documents and services without unnecessary delays.'
//           },
//           {
//             title: 'Experienced staff',
//             detail: 'Our team has 10+ years of experience in government documentation and online services. We know the process inside-out and guide you at every step.'
//           },
//           {
//             title: 'Affordable pricing',
//             detail: 'Transparent and competitive pricing with no hidden charges. We believe in fair rates that everyone can afford without compromising on quality.'
//           },
//           {
//             title: 'All services under one roof',
//             detail: 'From Aadhar to passport, PAN to vehicle registration - get everything done at one place. Save time and effort with our comprehensive service range.'
//           },
//           {
//             title: 'Proper documentation support',
//             detail: 'We help you prepare all required documents correctly. Our checklist ensures nothing is missing, avoiding rejection and saving your precious time.'
//           },
//           {
//             title: 'Timely completion',
//             detail: 'We track your application until completion and keep you updated at every stage. No need to follow up - we do it for you.'
//           }
//         ]
//       },
//       services: {
//         title: 'Our Complete Services',
//         subtitle: 'Everything You Need Under One Roof',
//         categories: [
//           {
//             name: 'ID & Documents',
//             icon: UserCheck,
//             services: [
//               'Aadhar Card - New Registration',
//               'Aadhar Card - Update/Correction',
//               'PAN Card - New Application',
//               'PAN Card - Correction/Reprint',
//               'Ration Card Application',
//               'Voter ID Card',
//               'Passport Application & Renewal',
//               'Birth Certificate',
//               'Death Certificate',
//               'Income Certificate',
//               'Domicile Certificate',
//               'Caste Certificate'
//             ]
//           },
//           {
//             name: 'Vehicle Services',
//             icon: Car,
//             services: [
//               'Learning License Application',
//               'Driving License - New',
//               'Driving License - Renewal',
//               'RC Transfer',
//               'Vehicle Registration',
//               'Duplicate RC',
//               'NOC for Vehicle',
//               'Vehicle Insurance',
//               'Pollution Certificate',
//               'Fitness Certificate',
//               'Fancy Number Application'
//             ]
//           },
//           {
//             name: 'Travel & Booking',
//             icon: Ticket,
//             services: [
//               'Railway Ticket Booking (IRCTC)',
//               'Tatkal Ticket Booking',
//               'Flight Ticket Booking',
//               'Bus Ticket Booking (MSRTC)',
//               'Hotel Booking',
//               'Visa Assistance',
//               'Travel Insurance'
//             ]
//           },
//           {
//             name: 'Government Forms',
//             icon: FileText,
//             services: [
//               'Income Tax Return Filing',
//               'GST Registration',
//               'GST Return Filing',
//               'FSSAI License',
//               'Shop Act License',
//               'Property Tax Payment',
//               'Electricity Bill Payment',
//               'Water Bill Payment',
//               'Gas Connection',
//               'Ration Card Form',
//               'Senior Citizen Card'
//             ]
//           },
//           {
//             name: 'Employment Services',
//             icon: Briefcase,
//             services: [
//               'PF Registration',
//               'PF Withdrawal',
//               'PF Transfer',
//               'ESI Registration',
//               'ESI Claim',
//               'Labour Card Registration',
//               'Unemployment Allowance',
//               'Employment Registration',
//               'Rojgar Melava Registration'
//             ]
//           },
//           {
//             name: 'Education Services',
//             icon: GraduationCap,
//             services: [
//               'Scholarship Application',
//               'School Admission Forms',
//               'College Admission Forms',
//               'Exam Form Filling',
//               'Education Loan Application',
//               'Certificate Verification',
//               'Migration Certificate',
//               'Bonafide Certificate'
//             ]
//           },
//           {
//             name: 'Property Services',
//             icon: Home,
//             services: [
//               '7/12 Extract',
//               '8A Extract',
//               'Property Registration',
//               'Property Tax',
//               'Mutation Entry',
//               'Property Search',
//               'Land Record',
//               'NOC for Construction'
//             ]
//           },
//           {
//             name: 'Utility & Bills',
//             icon: Zap,
//             services: [
//               'Electricity Bill Payment',
//               'MSEB New Connection',
//               'Water Bill Payment',
//               'Gas Bill Payment',
//               'Mobile Recharge',
//               'DTH Recharge',
//               'Broadband Bill Payment',
//               'Credit Card Bill Payment',
//               'Insurance Premium Payment'
//             ]
//           },
//           {
//             name: 'Social Welfare',
//             icon: Heart,
//             services: [
//               'Widow Pension',
//               'Old Age Pension',
//               'Disability Pension',
//               'Annapurna Yojana',
//               'Sanjay Gandhi Niradhar Yojana',
//               'Shravan Bal Seva Yojana',
//               'Handicap Certificate',
//               'Marriage Certificate'
//             ]
//           },
//           {
//             name: 'Other Services',
//             icon: Globe,
//             services: [
//               'Online Form Filling',
//               'Xerox & Printing',
//               'Scanning Services',
//               'Lamination',
//               'Passport Size Photo',
//               'Computer Training',
//               'Digital Signature',
//               'Email ID Creation',
//               'Resume Making',
//               'Notary Services'
//             ]
//           }
//         ]
//       },
//       why: {
//         title: 'Why Choose Us?',
//         points: [
//           {
//             title: 'Fast and reliable service',
//             detail: 'We complete most services within 24-48 hours. Our efficient process ensures you get your documents and services without unnecessary delays.'
//           },
//           {
//             title: 'Experienced staff',
//             detail: 'Our team has 10+ years of experience in government documentation and online services. We know the process inside-out and guide you at every step.'
//           },
//           {
//             title: 'Affordable pricing',
//             detail: 'Transparent and competitive pricing with no hidden charges. We believe in fair rates that everyone can afford without compromising on quality.'
//           },
//           {
//             title: 'All services under one roof',
//             detail: 'From Aadhar to passport, PAN to vehicle registration - get everything done at one place. Save time and effort with our comprehensive service range.'
//           },
//           {
//             title: 'Proper documentation support',
//             detail: 'We help you prepare all required documents correctly. Our checklist ensures nothing is missing, avoiding rejection and saving your precious time.'
//           },
//           {
//             title: 'Timely completion',
//             detail: 'We track your application until completion and keep you updated at every stage. No need to follow up - we do it for you.'
//           }
//         ]
//       },
//       contact: {
//         title: 'Contact Us',
//         subtitle: 'Visit us or get in touch',
//         address: 'Thane, Maharashtra',
//         phone: '+91 XXXXX XXXXX',
//         email: 'info@aaple-eseva.com',
//         hours: 'Mon - Sat: 9:00 AM - 8:00 PM'
//       }
//     },
//     mr: {
//       nav: {
//         home: 'मुख्यपृष्ठ',
//         services: 'सेवा',
//         about: 'आमच्याबद्दल',
//         contact: 'संपर्क'
//       },
//       hero: {
//         title: 'आपले सरकार ई-सेवा केंद्र',
//         subtitle: 'सर्व सरकारी आणि ऑनलाइन सेवांसाठी तुमचे एकच ठिकाण',
//         description: 'आम्ही सरकारी फॉर्म, ऑनलाइन नोंदणी, दस्तऐवज सेवा आणि बरेच काही यासाठी संपूर्ण मदत प्रदान करतो. जलद, विश्वासार्ह आणि परवडणाऱ्या किंमतीत सेवा.',
//         cta: 'सेवा पहा',
//         cta2: 'संपर्क करा'
//       },
//       why: {
//         title: 'आम्हाला का निवडावे?',
//         points: [
//           {
//             title: 'जलद आणि विश्वासार्ह सेवा',
//             detail: 'आम्ही बहुतेक सेवा २४-४८ तासांत पूर्ण करतो. आमची कार्यक्षम प्रक्रिया अनावश्यक विलंब न करता तुमचे दस्तऐवज आणि सेवा मिळवून देते.'
//           },
//           {
//             title: 'अनुभवी कर्मचारी',
//             detail: 'आमच्या टीमला सरकारी दस्तऐवजीकरण आणि ऑनलाइन सेवांमध्ये १०+ वर्षांचा अनुभव आहे. आम्हाला प्रक्रिया चांगल्या प्रकारे माहित आहे आणि प्रत्येक टप्प्यावर मार्गदर्शन करतो.'
//           },
//           {
//             title: 'परवडणारे दर',
//             detail: 'कोणतेही लपलेले शुल्क नसलेले पारदर्शक आणि स्पर्धात्मक किंमती. गुणवत्तेशी तडजोड न करता प्रत्येकाला परवडणारे योग्य दर देण्यावर आमचा विश्वास आहे.'
//           },
//           {
//             title: 'सर्व सेवा एकाच ठिकाणी',
//             detail: 'आधार ते पासपोर्ट, पॅन ते वाहन नोंदणी - सर्व काही एकाच ठिकाणी करवा. आमच्या व्यापक सेवा श्रेणीसह वेळ आणि मेहनत वाचवा.'
//           },
//           {
//             title: 'योग्य दस्तऐवज सहाय्य',
//             detail: 'आवश्यक सर्व कागदपत्रे योग्यरित्या तयार करण्यात आम्ही मदत करतो. आमची चेकलिस्ट काहीही गहाळ नाही याची खात्री करते, नाकारणे टाळते आणि तुमचा मौल्यवान वेळ वाचवते.'
//           },
//           {
//             title: 'वेळेवर पूर्ण होणे',
//             detail: 'पूर्ण होईपर्यंत आम्ही तुमच्या अर्जाचा मागोवा घेतो आणि प्रत्येक टप्प्यावर तुम्हाला अपडेट ठेवतो. फॉलो अप करण्याची गरज नाही - आम्ही ते तुमच्यासाठी करतो.'
//           }
//         ]
//       },
//       services: {
//         title: 'आमच्या संपूर्ण सेवा',
//         subtitle: 'एकाच छताखाली सर्व सेवा',
//         categories: [
//           {
//             name: 'ओळखपत्र आणि दस्तऐवज',
//             icon: UserCheck,
//             services: [
//               'आधार कार्ड - नवीन नोंदणी',
//               'आधार कार्ड - अपडेट/सुधारणा',
//               'पॅन कार्ड - नवीन अर्ज',
//               'पॅन कार्ड - सुधारणा/रिप्रिंट',
//               'रेशन कार्ड अर्ज',
//               'मतदार ओळखपत्र',
//               'पासपोर्ट अर्ज आणि नूतनीकरण',
//               'जन्म दाखला',
//               'मृत्यू दाखला',
//               'उत्पन्न दाखला',
//               'अधिवास दाखला',
//               'जात दाखला'
//             ]
//           },
//           {
//             name: 'वाहन सेवा',
//             icon: Car,
//             services: [
//               'शिकाऊ परवाना अर्ज',
//               'ड्रायव्हिंग लायसन्स - नवीन',
//               'ड्रायव्हिंग लायसन्स - नूतनीकरण',
//               'आरसी ट्रान्सफर',
//               'वाहन नोंदणी',
//               'डुप्लिकेट आरसी',
//               'वाहन NOC',
//               'वाहन विमा',
//               'प्रदूषण प्रमाणपत्र',
//               'फिटनेस प्रमाणपत्र',
//               'फॅन्सी नंबर अर्ज'
//             ]
//           },
//           {
//             name: 'प्रवास आणि बुकिंग',
//             icon: Ticket,
//             services: [
//               'रेल्वे तिकीट बुकिंग (IRCTC)',
//               'तत्काळ तिकीट बुकिंग',
//               'विमान तिकीट बुकिंग',
//               'बस तिकीट बुकिंग (MSRTC)',
//               'हॉटेल बुकिंग',
//               'व्हिसा सहाय्य',
//               'ट्रॅव्हल इन्शुरन्स'
//             ]
//           },
//           {
//             name: 'सरकारी फॉर्म',
//             icon: FileText,
//             services: [
//               'आयकर रिटर्न दाखल करणे',
//               'GST नोंदणी',
//               'GST रिटर्न दाखल करणे',
//               'FSSAI परवाना',
//               'शॉप ऍक्ट लायसन्स',
//               'मालमत्ता कर भरणा',
//               'वीज बिल भरणा',
//               'पाणी बिल भरणा',
//               'गॅस कनेक्शन',
//               'रेशन कार्ड फॉर्म',
//               'ज्येष्ठ नागरिक कार्ड'
//             ]
//           },
//           {
//             name: 'रोजगार सेवा',
//             icon: Briefcase,
//             services: [
//               'PF नोंदणी',
//               'PF पैसे काढणे',
//               'PF ट्रान्सफर',
//               'ESI नोंदणी',
//               'ESI दावा',
//               'कामगार कार्ड नोंदणी',
//               'बेरोजगारी भत्ता',
//               'रोजगार नोंदणी',
//               'रोजगार मेळावा नोंदणी'
//             ]
//           },
//           {
//             name: 'शिक्षण सेवा',
//             icon: GraduationCap,
//             services: [
//               'शिष्यवृत्ती अर्ज',
//               'शाळा प्रवेश फॉर्म',
//               'महाविद्यालय प्रवेश फॉर्म',
//               'परीक्षा फॉर्म भरणे',
//               'शिक्षण कर्ज अर्ज',
//               'प्रमाणपत्र पडताळणी',
//               'स्थलांतर प्रमाणपत्र',
//               'बोनाफाइड प्रमाणपत्र'
//             ]
//           },
//           {
//             name: 'मालमत्ता सेवा',
//             icon: Home,
//             services: [
//               '७/१२ उतारा',
//               '८अ उतारा',
//               'मालमत्ता नोंदणी',
//               'मालमत्ता कर',
//               'म्युटेशन एंट्री',
//               'मालमत्ता शोध',
//               'जमीन रेकॉर्ड',
//               'बांधकाम NOC'
//             ]
//           },
//           {
//             name: 'उपयोगिता आणि बिले',
//             icon: Zap,
//             services: [
//               'वीज बिल भरणा',
//               'MSEB नवीन कनेक्शन',
//               'पाणी बिल भरणा',
//               'गॅस बिल भरणा',
//               'मोबाईल रिचार्ज',
//               'DTH रिचार्ज',
//               'ब्रॉडबँड बिल भरणा',
//               'क्रेडिट कार्ड बिल भरणा',
//               'विमा प्रिमियम भरणा'
//             ]
//           },
//           {
//             name: 'समाज कल्याण',
//             icon: Heart,
//             services: [
//               'विधवा पेन्शन',
//               'वृद्धापकाळ पेन्शन',
//               'अपंगत्व पेन्शन',
//               'अन्नपूर्णा योजना',
//               'संजय गांधी निराधार योजना',
//               'श्रावण बाल सेवा योजना',
//               'अपंग प्रमाणपत्र',
//               'विवाह नोंदणी प्रमाणपत्र'
//             ]
//           },
//           {
//             name: 'इतर सेवा',
//             icon: Globe,
//             services: [
//               'ऑनलाइन फॉर्म भरणे',
//               'झेरॉक्स आणि प्रिंटिंग',
//               'स्कॅनिंग सेवा',
//               'लॅमिनेशन',
//               'पासपोर्ट साईज फोटो',
//               'संगणक प्रशिक्षण',
//               'डिजिटल स्वाक्षरी',
//               'ईमेल आयडी निर्मिती',
//               'रेझ्युमे तयार करणे',
//               'नोटरी सेवा'
//             ]
//           }
//         ]
//       },
//       why: {
//         title: 'आम्हाला का निवडावे?',
//         points: [
//           {
//             title: 'जलद आणि विश्वासार्ह सेवा',
//             detail: 'आम्ही बहुतेक सेवा २४-४८ तासांत पूर्ण करतो. आमची कार्यक्षम प्रक्रिया अनावश्यक विलंब न करता तुमचे दस्तऐवज आणि सेवा मिळवून देते.'
//           },
//           {
//             title: 'अनुभवी कर्मचारी',
//             detail: 'आमच्या टीमला सरकारी दस्तऐवजीकरण आणि ऑनलाइन सेवांमध्ये १०+ वर्षांचा अनुभव आहे. आम्हाला प्रक्रिया चांगल्या प्रकारे माहित आहे आणि प्रत्येक टप्प्यावर मार्गदर्शन करतो.'
//           },
//           {
//             title: 'परवडणारे दर',
//             detail: 'कोणतेही लपलेले शुल्क नसलेले पारदर्शक आणि स्पर्धात्मक किंमती. गुणवत्तेशी तडजोड न करता प्रत्येकाला परवडणारे योग्य दर देण्यावर आमचा विश्वास आहे.'
//           },
//           {
//             title: 'सर्व सेवा एकाच ठिकाणी',
//             detail: 'आधार ते पासपोर्ट, पॅन ते वाहन नोंदणी - सर्व काही एकाच ठिकाणी करवा. आमच्या व्यापक सेवा श्रेणीसह वेळ आणि मेहनत वाचवा.'
//           },
//           {
//             title: 'योग्य दस्तऐवज सहाय्य',
//             detail: 'आवश्यक सर्व कागदपत्रे योग्यरित्या तयार करण्यात आम्ही मदत करतो. आमची चेकलिस्ट काहीही गहाळ नाही याची खात्री करते, नाकारणे टाळते आणि तुमचा मौल्यवान वेळ वाचवते.'
//           },
//           {
//             title: 'वेळेवर पूर्ण होणे',
//             detail: 'पूर्ण होईपर्यंत आम्ही तुमच्या अर्जाचा मागोवा घेतो आणि प्रत्येक टप्प्यावर तुम्हाला अपडेट ठेवतो. फॉलो अप करण्याची गरज नाही - आम्ही ते तुमच्यासाठी करतो.'
//           }
//         ]
//       },
//       contact: {
//         title: 'आमच्याशी संपर्क साधा',
//         subtitle: 'आमच्याकडे भेट द्या किंवा संपर्कात रहा',
//         address: 'ठाणे, महाराष्ट्र',
//         phone: '+91 XXXXX XXXXX',
//         email: 'info@aaple-eseva.com',
//         hours: 'सोम - शनि: सकाळी 9:00 - रात्री 8:00'
//       }
//     }
//   };

//   const t = content[language];

//   return (
//     <>
//       <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Poppins', sans-serif, 'Noto Sans Devanagari', sans-serif;
//           line-height: 1.6;
//         }
        
        
//         @keyframes gradientShift {
//           0% {
//             background-position: 0% 50%;
//           }
//           50% {
//             background-position: 100% 50%;
//           }
//           100% {
//             background-position: 0% 50%;
//           }
//         }


//         .container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px;
//         }

//         /* Header Styles */
//         .header {
//           background: linear-gradient(135deg, #ffffff 0%, #fff5f2 100%);
//           box-shadow: 0 4px 20px rgba(0,0,0,0.08);
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           backdrop-filter: blur(10px);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 16px 0;
//         }

//         .logo-section {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }

//         .logo-icon {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
//         }

//         .logo-text h1 {
//           font-size: 20px;
//           color: #1a1a1a;
//           margin-bottom: 2px;
//         }

//         .logo-text p {
//           font-size: 12px;
//           color: #666;
//         }

//         .nav {
//           display: flex;
//           gap: 32px;
//         }

//         .nav a {
//           color: #333;
//           text-decoration: none;
//           font-weight: 500;
//           transition: color 0.3s;
//         }

//         .nav a:hover {
//           color: #ff6b35;
//         }

//         .lang-btn {
//           padding: 10px 20px;
//           background: #fff5f2;
//           color: #ff6b35;
//           border: none;
//           border-radius: 8px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: background 0.3s;
//         }

//         .lang-btn:hover {
//           background: #ffe5dc;
//         }

//         /* Hero Section */
//         .hero {
//           background: linear-gradient(-45deg, #c94b4b , #4b134f , #1e3a8a, #065f46 );
//           background-size: 400% 400%;
//           animation: gradientShift 15s ease infinite;
//           padding: 100px 0;
//           text-align: center;
//           position: relative;
//           overflow: hidden;
//         }

//         .hero::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -20%;
//           width: 500px;
//           height: 500px;
//           background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
//           border-radius: 50%;
//           animation: floatAnimation 6s ease-in-out infinite;
//         }

//         .hero::after {
//           content: '';
//           position: absolute;
//           bottom: -30%;
//           left: -10%;
//           width: 400px;
//           height: 400px;
//           background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
//           border-radius: 50%;
//           animation: floatAnimation 8s ease-in-out infinite reverse;
//         }

//         .hero > .container {
//           position: relative;
//           z-index: 1;
//           animation: scaleIn 1s ease;
//         }

//         .hero h2 {
//           font-size: 52px;
//           color: white;
//           margin-bottom: 16px;
//           font-weight: 800;
//           text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
//           animation: slideInFromLeft 1s ease;
//         }

//         .hero .subtitle {
//           font-size: 24px;
//           color: white;
//           font-weight: 600;
//           margin-bottom: 24px;
//           text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
//           animation: slideInFromRight 1s ease;
//         }

//         .hero .description {
//           font-size: 18px;
//           color: rgba(255, 255, 255, 0.95);
//           max-width: 800px;
//           margin: 0 auto 32px;
//           text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
//           animation: scaleIn 1.2s ease;
//         }
//         .cta-buttons {
//           display: flex;
//           gap: 16px;
//           justify-content: center;
//           flex-wrap: wrap;
//         }

//         .btn-primary {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 14px 24px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           text-decoration: none;
//           border-radius: 50px;
//           font-weight: 600;
//           transition: all 0.3s;
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.3);
//           position: relative;
//           overflow: hidden;
//         }

//         .btn-primary::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
//           transition: left 0.5s;
//         }

//         .btn-primary:hover::before {
//           left: 100%;
//         }

//         .btn-primary:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 12px 32px rgba(255, 107, 53, 0.4);
//         }

//         .btn-secondary {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           padding: 6px 24px;
//           background: white;
//           color: #ff6b35;
//           text-decoration: none;
//           border: 2px solid #ff6b35;
//           border-radius: 50px;
//           font-weight: 600;
//           transition: all 0.3s;
//           box-shadow: 0 4px 16px rgba(255, 107, 53, 0.1);
//         }

//         .btn-secondary:hover {
//           background: #ff6b35;
//           color: white;
//           transform: translateY(-2px);
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.3);
//         }

//         /* Services Section */
//         .services {
//           padding: 100px 0;
//           background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
//           position: relative;
//         }

//         .services::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 1px;
//           background: linear-gradient(90deg, transparent, #ff6b35, transparent);
//         }

//         .section-header {
//           text-align: center;
//           margin-bottom: 40px;
//         }

//         .section-header h3 {
//           font-size: 40px;
//           color: #1a1a1a;
//           margin-bottom: 16px;
//         }

//         .section-header p {
//           font-size: 18px;
//           color: #666;
//         }

//         /* Tabs */
//         .tabs-container {
//           margin-bottom: 20px;
//         }

//         .tabs {
//           display: flex;
//           gap: 8px;
//           overflow-x: auto;
//           padding-top: 16px;
//           padding-bottom: 16px;
//           margin-bottom: 20px;
//           border-bottom: 2px solid #f0f0f0;
//         }

//         .tabs::-webkit-scrollbar {
//           height: 6px;
//         }

//         .tabs::-webkit-scrollbar-thumb {
//           background: #ddd;
//           border-radius: 3px;
//         }

//         .tab-button {
//           font-family: 'Poppins', sans-serif;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           padding: 14px 28px;
//           background: white;
//           border: 2px solid #e0e0e0;
//           border-radius: 50px;
//           cursor: pointer;
//           transition: all 0.3s;
//           white-space: nowrap;
//           font-size: 15px;
//           font-weight: 500;
//           color: #666;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
//         }

//         .tab-button:hover {
//           border-color: #ff6b35;
//           color: #ff6b35;
//           transform: translateY(-2px);
//           box-shadow: 0 4px 12px rgba(255, 107, 53, 0.15);
//         }

//         .tab-button.active {
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-color: #ff6b35;
//           color: white;
//           box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
//         }

//         .tab-content {
//           animation: fadeIn 0.4s;
//         }

//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .services-list {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
//           gap: 16px;
//         }

//         .service-item {
//           background: white;
//           padding: 20px 24px;
//           border-radius: 12px;
//           border-left: 4px solid #ff6b35;
//           transition: all 0.3s;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
//           position: relative;
//           overflow: hidden;
//         }

//         .service-item::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 4px;
//           height: 100%;
//           background: linear-gradient(180deg, #ff6b35 0%, #ff8c42 100%);
//         }

//         .service-item:hover {
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           transform: translateX(8px);
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.15);
//           border-left-color: #ff8c42;
//         }

//         .service-bullet {
//           width: 10px;
//           height: 10px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-radius: 50%;
//           flex-shrink: 0;
//           box-shadow: 0 2px 6px rgba(255, 107, 53, 0.3);
//         }

//         .service-item span {
//           color: #333;
//           font-size: 15px;
//           font-weight: 500;
//         }

//         /* Why Choose Us Section */
//         .why-section {
//           padding: 100px 0;
//           // background: linear-gradient(135deg, #fff5f2 0%, #ffe9e0 50%, #fff5f2 100%);
//           position: relative;
//           overflow: hidden;
//         }

//         .why-section::before {
//           content: '';
//           position: absolute;
//           top: -100px;
//           left: -100px;
//           width: 300px;
//           height: 300px;
//           background: radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%);
//           border-radius: 50%;
//         }

//         .why-section::after {
//           content: '';
//           position: absolute;
//           bottom: -150px;
//           right: -150px;
//           width: 400px;
//           height: 400px;
//           background: radial-gradient(circle, rgba(255, 140, 66, 0.08) 0%, transparent 70%);
//           border-radius: 50%;
//         }

//         .why-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           gap: 24px;
//         }

//         .why-card {
//           background: white;
//           padding: 28px;
//           border-radius: 16px;
//           box-shadow: 0 4px 16px rgba(0,0,0,0.08);
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//           overflow: hidden;
//           border: 2px solid transparent;
//         }

//         .why-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 4px;
//           background: linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%);
//           transform: scaleX(0);
//           transition: transform 0.3s ease;
//         }

//         .why-card:hover::before {
//           transform: scaleX(1);
//         }

//         .why-card:hover {
//           box-shadow: 0 8px 32px rgba(255, 107, 53, 0.2);
//           transform: translateY(-4px);
//           border-color: #ffe5dc;
//         }

//         .why-card-header {
//           display: flex;
//           align-items: flex-start;
//           gap: 16px;
//         }

//         .why-icon {
//           width: 28px;
//           height: 28px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//           margin-top: 4px;
//           box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
//         }

//         .why-card-title {
//           color: #333;
//           font-weight: 600;
//           font-size: 16px;
//           flex: 1;
//         }

//         .why-card-detail {
//           color: #666;
//           font-size: 14px;
//           line-height: 1.6;
//           margin-left: 40px;
//           max-height: 0;
//           opacity: 0;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }

//         .why-card.expanded .why-card-detail {
//           max-height: 200px;
//           opacity: 1;
//           margin-top: 8px;
//         }

//         .why-card.expanded {
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           box-shadow: 0 12px 40px rgba(255, 107, 53, 0.25);
//           border-color: #ff6b35;
//         }

//         .expand-indicator {
//           position: absolute;
//           top: 28px;
//           right: 28px;
//           width: 28px;
//           height: 28px;
//           border-radius: 50%;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 20px;
//           font-weight: bold;
//           transition: transform 0.3s ease;
//           box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
//         }

//         .why-card.expanded .expand-indicator {
//           transform: rotate(45deg);
//         }

//         /* Testimonials Section */
//         .testimonials-section {
//           padding: 100px 0;
//           background: #f8f9fa;
//           position: relative;
//         }

//         .testimonials-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px;
//         }

//         .testimonials-header {
//           text-align: center;
//           margin-bottom: 60px;
//         }

//         .testimonials-header h3 {
//           font-size: 40px;
//           color: #1a1a1a;
//           margin-bottom: 16px;
//         }

//         .testimonials-header p {
//           font-size: 18px;
//           color: #666;
//         }

//         .testimonials-slider {
//           position: relative;
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         .testimonial-card {
//           background: white;
//           padding: 56px;
//           border-radius: 24px;
//           box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);
//           position: relative;
//           animation: fadeInScale 0.5s ease;
//           border: 3px solid #fff5f2;
//         }

//         @keyframes fadeInScale {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .quote-icon {
//           position: absolute;
//           top: 24px;
//           left: 24px;
//           color: #ff6b35;
//           opacity: 0.2;
//         }

//         .rating {
//           display: flex;
//           gap: 4px;
//           margin-bottom: 20px;
//           justify-content: center;
//         }

//         .testimonial-text {
//           font-size: 18px;
//           line-height: 1.8;
//           color: #333;
//           margin-bottom: 32px;
//           text-align: center;
//           font-style: italic;
//         }

//         .testimonial-author {
//           text-align: center;
//         }

//         .author-name {
//           font-size: 20px;
//           font-weight: 600;
//           color: #1a1a1a;
//           margin-bottom: 4px;
//         }

//         .author-service {
//           font-size: 15px;
//           color: #ff6b35;
//           font-weight: 500;
//           margin-bottom: 4px;
//         }

//         .author-location {
//           font-size: 14px;
//           color: #999;
//         }

//         .slider-controls {
//           display: flex;
//           justify-content: center;
//           gap: 16px;
//           margin-top: 32px;
//         }

//         .slider-button {
//           width: 56px;
//           height: 56px;
//           border-radius: 50%;
//           border: 3px solid #ff6b35;
//           background: white;
//           color: #ff6b35;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.3s;
//           box-shadow: 0 4px 16px rgba(255, 107, 53, 0.2);
//         }

//         .slider-button:hover {
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           transform: scale(1.1);
//           box-shadow: 0 6px 24px rgba(255, 107, 53, 0.4);
//         }

//         .slider-dots {
//           display: flex;
//           justify-content: center;
//           gap: 8px;
//           margin-top: 24px;
//         }

//         .dot {
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: #ddd;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .dot.active {
//           background: #ff6b35;
//           width: 32px;
//           border-radius: 5px;
//         }

//         /* Contact Section */
//         .contact-section {
//           padding: 100px 0;
//           // background: linear-gradient(135deg, #fff5f2 0%, #ffe9e0 50%, #ffffff 100%);
//           position: relative;
//         }

//         .contact-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 32px;
//           margin-top: 60px;
//         }

//         .contact-card {
//           text-align: center;
//           transition: transform 0.3s ease;
//         }

//         .contact-card:hover {
//           transform: translateY(-8px);
//         }

//         .contact-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 20px;
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.15);
//           transition: all 0.3s ease;
//         }

//         .contact-card:hover .contact-icon {
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.15);
//         }

//         .contact-card:hover .contact-icon svg {
//           color: white !important;
//         }

//         .contact-card h4 {
//           font-size: 18px;
//           color: #1a1a1a;
//           margin-bottom: 8px;
//         }

//         .contact-card p {
//           color: #666;
//           font-size: 16px;
//         }
        
//         .contact-map-grid{
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//         }

//         /* Footer */
//         .footer {
//           background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
//           color: white;
//           padding: 48px 0;
//           text-align: center;
//           position: relative;
//         }

//         .footer::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 2px;
//           background: linear-gradient(90deg, transparent, #ff6b35, transparent);
//         }

//         .footer p {
//           color: #999;
//         }

//         /* WhatsApp Button */
//         .whatsapp-float {
//           position: fixed;
//           bottom: 30px;
//           right: 30px;
//           background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
//           color: white;
//           width: 64px;
//           height: 64px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           box-shadow: 0 8px 24px rgba(37, 211, 102, 0.4);
//           z-index: 1000;
//           transition: all 0.3s ease;
//           border: none;
//         }

//         .whatsapp-float:hover {
//           transform: scale(1.15);
//           box-shadow: 0 12px 32px rgba(37, 211, 102, 0.6);
//         }

//         .whatsapp-pulse {
//           animation: pulse 2s infinite;
//         }

//         @keyframes pulse {
//           0%, 100% {
//             box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
//           }
//           50% {
//             box-shadow: 0 4px 20px rgba(37, 211, 102, 0.7);
//           }
//         }

//         /* Request Form Button */
//         .request-form-button {
//           position: fixed;
//           bottom: 115px;
//           right: 30px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           padding: 16px 28px;
//           border-radius: 50px;
//           border: none;
//           cursor: pointer;
//           font-weight: 600;
//           font-size: 15px;
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.4);
//           z-index: 999;
//           transition: all 0.3s ease;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .request-form-button:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 12px 32px rgba(255, 107, 53, 0.5);
//         }

//         /* Form Overlay */
//         .form-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.5);
//           z-index: 1001;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//           animation: fadeIn 0.3s ease;
//         }

//         .form-container {
//           background: white;
//           border-radius: 16px;
//           padding: 32px;
//           max-width: 500px;
//           width: 100%;
//           max-height: 90vh;
//           overflow-y: auto;
//           position: relative;
//           animation: slideUp 0.3s ease;
//         }

//         @keyframes slideUp {
//           from {
//             transform: translateY(50px);
//             opacity: 0;
//           }
//           to {
//             transform: translateY(0);
//             opacity: 1;
//           }
//         }

//         .form-header {
//           margin-bottom: 24px;
//         }

//         .form-header h3 {
//           font-size: 24px;
//           color: #1a1a1a;
//           margin-bottom: 8px;
//         }

//         .form-header p {
//           color: #666;
//           font-size: 14px;
//         }

//         .close-button {
//           position: absolute;
//           top: 20px;
//           right: 20px;
//           background: #f5f5f5;
//           border: none;
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s;
//         }

//         .close-button:hover {
//           background: #e0e0e0;
//         }

//         .form-group {
//           margin-bottom: 20px;
//         }

//         .form-group label {
//           display: block;
//           margin-bottom: 8px;
//           color: #333;
//           font-weight: 500;
//           font-size: 14px;
//         }

//         .form-group input,
//         .form-group select,
//         .form-group textarea {
//           width: 100%;
//           padding: 12px 16px;
//           border: 2px solid #e0e0e0;
//           border-radius: 8px;
//           font-size: 15px;
//           transition: border-color 0.3s;
//           font-family: inherit;
//         }

//         .form-group input:focus,
//         .form-group select:focus,
//         .form-group textarea:focus {
//           outline: none;
//           border-color: #ff6b35;
//         }

//         .form-group textarea {
//           resize: vertical;
//           min-height: 80px;
//         }

//         .submit-button {
//           width: 100%;
//           padding: 16px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           border: none;
//           border-radius: 12px;
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           transition: all 0.3s;
//           box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
//         }

//         .submit-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 28px rgba(255, 107, 53, 0.4);
//         }

//         .success-message {
//           text-align: center;
//           padding: 40px 20px;
//         }

//         .success-message h4 {
//           color: #25D366;
//           font-size: 20px;
//           margin-bottom: 12px;
//         }

//         .success-message p {
//           color: #666;
//           font-size: 15px;
//         }

//         /* Scroll to Top */
//         .scroll-to-top {
//           position: fixed;
//           bottom: 30px;
//           left: 30px;
//           background: linear-gradient(135deg, #333 0%, #1a1a1a 100%);
//           color: white;
//           width: 56px;
//           height: 56px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
//           z-index: 998;
//           transition: all 0.3s ease;
//           border: none;
//           opacity: 0;
//           visibility: hidden;
//           transform: translateY(20px);
//         }

//         .scroll-to-top.visible {
//           opacity: 1;
//           visibility: visible;
//           transform: translateY(0);
//         }

//         .scroll-to-top:hover {
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           transform: translateY(-6px);
//           box-shadow: 0 10px 32px rgba(255, 107, 53, 0.4);
//         }

//         /* Mobile Responsive */
//         @media (max-width: 768px) {
//           .nav {
//             display: none;
//           }
//            .hero{
//           padding:60px 0
//           }
//           .hero h2 {
//             font-size: 32px;
//           }

//           .hero .subtitle {
//             font-size: 18px;
//           }

//           .hero .description {
//             font-size: 16px;
//           }

//           .section-header h3, .testimonials-header h3 {
//             font-size: 28px;
//           }

//           .services-list {
//             grid-template-columns: 1fr;
//           }

//           .tabs {
//             gap: 6px;
//           }

//           .tab-button {
//             padding: 10px 16px;
//             font-size: 14px;
//           }

//           .whatsapp-float {
//             width: 56px;
//             height: 56px;
//             bottom: 20px;
//             right: 20px;
//           }

//           .request-form-button {
//             bottom: 90px;
//             right: 20px;
//             padding: 12px 20px;
//             font-size: 14px;
//           }

//           .scroll-to-top {
//             width: 46px;
//             height: 46px;
//             bottom: 20px;
//             left: 20px;
//           }

//           .testimonial-card {
//             padding: 32px 24px;
//           }

//           .testimonial-text {
//             font-size: 16px;
//           }

//           .quote-icon {
//             display: none;
//           }
//             .contact-map-grid{
//             grid-template-columns: 1fr;}
//         }
//       `}</style>

//       <div>
//         {/* Header */}
//         <header className="header">
//           <div className="container">
//             <div className="header-content">
//               <div className="logo-section">
//                 <div className="logo-icon">
//                   <Globe color="white" size={24} />
//                 </div>
//                 <div className="logo-text">
//                   <h1>{language === 'mr' ? 'श्री एंटरप्रायझेस' : 'Shree Digital Solutions And Services'}</h1>
//                   <p>{language === 'mr' ? 'ई-सेवा केंद्र' : 'E-Seva Kendra'}</p>
//                 </div>
//               </div>

//            <nav className="nav">
//               <Link to="#home">{t.nav.home}</Link>
//               <Link to="#services">{t.nav.services}</Link>
//               <Link to="#about">{t.nav.about}</Link>
//               <Link to="#contact">{t.nav.contact}</Link>
//               <Link to="/blogs">Blogs</Link>
//             </nav>

//               <button onClick={() => setLanguage(language === 'mr' ? 'en' : 'mr')} className="lang-btn">
//                 {language === 'mr' ? 'English' : 'मराठी'}
//               </button>
//             </div>
//           </div>
//         </header>

//         {/* Hero Section */}
//         <section id="home" className="hero">
//           <div className="container">
//             <h2>{t.hero.title}</h2>
//             <p className="subtitle">{t.hero.subtitle}</p>
//             <p className="description">{t.hero.description}</p>
//             <div className="cta-buttons">
//               <a href="#services" className="btn-primary">
//                 {t.hero.cta}
//                 <ChevronRight size={20} />
//               </a>
//               <a href="#contact" className="btn-secondary">
//                 {t.hero.cta2}
//               </a>
//             </div>
//           </div>
//         </section>

//         {/* Services Section with Tabs */}
//         <section id="services" className="services">
//           <div className="container">
//             <div className="section-header">
//               <h3>{t.services.title}</h3>
//               <p>{t.services.subtitle}</p>
//             </div>

//             <div className="tabs-container">
//               <div className="tabs">
//                 {t.services.categories.map((category, index) => {
//                   const Icon = category.icon;
//                   return (
//                     <button
//                       key={index}
//                       className={`tab-button ${activeTab === index ? 'active' : ''}`}
//                       onClick={() => setActiveTab(index)}
//                     >
//                       <Icon size={18} />
//                       {category.name}
//                     </button>
//                   );
//                 })}
//               </div>

//               <div className="tab-content">
//                 <div className="services-list">
//                   {t.services.categories[activeTab].services.map((service, index) => (
//                     <div key={index} className="service-item">
//                       <div className="service-bullet"></div>
//                       <span>{service}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Why Choose Us Section */}
//         <section id="about" className="why-section">
//           <div className="container">
//             <div className="section-header">
//               <h3>{t.why.title}</h3>
//             </div>

//             <div className="why-grid">
//               {t.why.points.map((point, index) => (
//                 <div 
//                   key={index} 
//                   className={`why-card ${expandedCard === index ? 'expanded' : ''}`}
//                   onClick={() => toggleCard(index)}
//                 >
//                   <div className="why-card-header">
//                     <div className="why-icon">
//                       <ChevronRight color="white" size={16} />
//                     </div>
//                     <p className="why-card-title">{point.title}</p>
//                   </div>
//                   <div className="why-card-detail">
//                     {point.detail}
//                   </div>
//                   <div className="expand-indicator">+</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Testimonials Section */}
//         <Testimonials language={language} />

//         {/* Contact Section */}
//         <section id="contact" className="contact-section">
//           <div className="container">
//             <div className="section-header">
//               <h3>{t.contact.title}</h3>
//               <p>{t.contact.subtitle}</p>
//             </div>

//            <div className='contact-map-grid'>
//               <div className='map-grid'>
//                 <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60288.71434102667!2d72.9764739417712!3d19.193252231726778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bf8a00230155%3A0xc0bcc84fd31a6666!2sShree%20Enterprises!5e0!3m2!1sen!2sin!4v1764085269928!5m2!1sen!2sin" width="100%" height="450" style={{border:0 }}allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
//               </div>
//              <div className="contact-grid">
//               <div className="contact-card">
//                 <div className="contact-icon">
//                   <MapPin color="#ff6b35" size={32} />
//                 </div>
//                 <h4>{language === 'mr' ? 'पत्ता' : 'Address'}</h4>
//                 <p>{t.contact.address}</p>
//               </div>

//               <div className="contact-card">
//                 <div className="contact-icon">
//                   <Phone color="#ff6b35" size={32} />
//                 </div>
//                 <h4>{language === 'mr' ? 'फोन' : 'Phone'}</h4>
//                 <p>{t.contact.phone}</p>
//               </div>

//               <div className="contact-card">
//                 <div className="contact-icon">
//                   <Mail color="#ff6b35" size={32} />
//                 </div>
//                 <h4>{language === 'mr' ? 'ईमेल' : 'Email'}</h4>
//                 <p>{t.contact.email}</p>
//               </div>

//               <div className="contact-card">
//                 <div className="contact-icon">
//                   <Clock color="#ff6b35" size={32} />
//                 </div>
//                 <h4>{language === 'mr' ? 'वेळ' : 'Hours'}</h4>
//                 <p>{t.contact.hours}</p>
//               </div>
//             </div>
//            </div>
//           </div>
//         </section>

//         {/* Footer */}
//         <footer className="footer">
//           <div className="container">
//             <p>
//               © 2025 {language === 'mr' ? 'श्री एंटरप्रायझेस ई-सेवा केंद्र.' : 'Shree Digital Solutions And Services E-Seva Kendra.'} {' '}
//               {language === 'mr' ? 'सर्व हक्क राखीव.' : 'All rights reserved.'}
//             </p>
//           </div>
//         </footer>

//         {/* Floating Components */}
//         <WhatsAppButton phoneNumber="919321415838" message="Hello, I need help with a service" />
//         <ServiceRequestForm language={language} />
//         <ScrollToTop />
//       </div>
//     </>
//   );
// }



// ============================================
import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ServiceRequestForm from './components/ServiceRequestForm';
import ScrollToTop from './components/ScrollToTop';
import { content } from './data/content';
import { globalStyles } from './styles/globalStyles';
// import ArticlesSection from './components/ArticlesSection';
import Testimonials from './components/Testimonials';
import { useLanguage } from './context/LanguageContext';
import MainServices from './components/MainServices';

const HomePage = () => {

  const { language } = useLanguage();


  return (
    <>
      <style>{globalStyles}</style>
      
      <div>
        <Header language={language} content={content} />
        <Hero language={language} content={content} />
        <MainServices language={language} content={content} />
        <Services language={language} content={content} />
        <WhyChooseUs language={language} content={content} />
        {/* <ArticlesSection language={language} content={content} /> */}
        <Testimonials language={language} content={content} />
        <Contact language={language} content={content} />
        <Footer language={language} />
        
        <WhatsAppButton phoneNumber="919321415838" message="Hello, I need help with a service" />
        <ServiceRequestForm language={language} content={content} />
        <ScrollToTop />
      </div>
    </>
  );
};

export default HomePage;